import React from 'react';
import { Container, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';

const MoneyGift = () => {
  const gifts = [
    { bankName: 'CIMB Bank', accountNumber: '8901234567', eventSelected: 'Event 1', status: 'Active' },
    { bankName: 'Maybank', accountNumber: '130123456790', eventSelected: 'Event 2', status: 'Closed' },
  ];

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Money Gift
      </Typography>
      <Button variant="contained" color="primary" style={{ marginBottom: '16px' }}>
        Add
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Bank Name</TableCell>
              <TableCell>Account Number</TableCell>
              <TableCell>Event Selected</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {gifts.map((gift, index) => (
              <TableRow key={index}>
                <TableCell>{gift.bankName}</TableCell>
                <TableCell>{gift.accountNumber}</TableCell>
                <TableCell>{gift.eventSelected}</TableCell>
                <TableCell>{gift.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default MoneyGift;